export default "__VITE_ASSET__Bc6gnUjm__"